/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdRolesOk
 */
export interface GetCharactersCharacterIdRolesOk {
    /**
     * roles array
     * @type {Array<string>}
     * @memberof GetCharactersCharacterIdRolesOk
     */
    roles?: Array<GetCharactersCharacterIdRolesOkRolesEnum>;
    /**
     * roles_at_base array
     * @type {Array<string>}
     * @memberof GetCharactersCharacterIdRolesOk
     */
    rolesAtBase?: Array<GetCharactersCharacterIdRolesOkRolesAtBaseEnum>;
    /**
     * roles_at_hq array
     * @type {Array<string>}
     * @memberof GetCharactersCharacterIdRolesOk
     */
    rolesAtHq?: Array<GetCharactersCharacterIdRolesOkRolesAtHqEnum>;
    /**
     * roles_at_other array
     * @type {Array<string>}
     * @memberof GetCharactersCharacterIdRolesOk
     */
    rolesAtOther?: Array<GetCharactersCharacterIdRolesOkRolesAtOtherEnum>;
}


/**
 * @export
 */
export const GetCharactersCharacterIdRolesOkRolesEnum = {
    AccountTake1: 'Account_Take_1',
    AccountTake2: 'Account_Take_2',
    AccountTake3: 'Account_Take_3',
    AccountTake4: 'Account_Take_4',
    AccountTake5: 'Account_Take_5',
    AccountTake6: 'Account_Take_6',
    AccountTake7: 'Account_Take_7',
    Accountant: 'Accountant',
    Auditor: 'Auditor',
    BrandManager: 'Brand_Manager',
    CommunicationsOfficer: 'Communications_Officer',
    ConfigEquipment: 'Config_Equipment',
    ConfigStarbaseEquipment: 'Config_Starbase_Equipment',
    ContainerTake1: 'Container_Take_1',
    ContainerTake2: 'Container_Take_2',
    ContainerTake3: 'Container_Take_3',
    ContainerTake4: 'Container_Take_4',
    ContainerTake5: 'Container_Take_5',
    ContainerTake6: 'Container_Take_6',
    ContainerTake7: 'Container_Take_7',
    ContractManager: 'Contract_Manager',
    DeliveriesContainerTake: 'Deliveries_Container_Take',
    DeliveriesQuery: 'Deliveries_Query',
    DeliveriesTake: 'Deliveries_Take',
    Diplomat: 'Diplomat',
    Director: 'Director',
    FactoryManager: 'Factory_Manager',
    FittingManager: 'Fitting_Manager',
    HangarQuery1: 'Hangar_Query_1',
    HangarQuery2: 'Hangar_Query_2',
    HangarQuery3: 'Hangar_Query_3',
    HangarQuery4: 'Hangar_Query_4',
    HangarQuery5: 'Hangar_Query_5',
    HangarQuery6: 'Hangar_Query_6',
    HangarQuery7: 'Hangar_Query_7',
    HangarTake1: 'Hangar_Take_1',
    HangarTake2: 'Hangar_Take_2',
    HangarTake3: 'Hangar_Take_3',
    HangarTake4: 'Hangar_Take_4',
    HangarTake5: 'Hangar_Take_5',
    HangarTake6: 'Hangar_Take_6',
    HangarTake7: 'Hangar_Take_7',
    JuniorAccountant: 'Junior_Accountant',
    PersonnelManager: 'Personnel_Manager',
    ProjectManager: 'Project_Manager',
    RentFactoryFacility: 'Rent_Factory_Facility',
    RentOffice: 'Rent_Office',
    RentResearchFacility: 'Rent_Research_Facility',
    SecurityOfficer: 'Security_Officer',
    SkillPlanManager: 'Skill_Plan_Manager',
    StarbaseDefenseOperator: 'Starbase_Defense_Operator',
    StarbaseFuelTechnician: 'Starbase_Fuel_Technician',
    StationManager: 'Station_Manager',
    Trader: 'Trader'
} as const;
export type GetCharactersCharacterIdRolesOkRolesEnum = typeof GetCharactersCharacterIdRolesOkRolesEnum[keyof typeof GetCharactersCharacterIdRolesOkRolesEnum];

/**
 * @export
 */
export const GetCharactersCharacterIdRolesOkRolesAtBaseEnum = {
    AccountTake1: 'Account_Take_1',
    AccountTake2: 'Account_Take_2',
    AccountTake3: 'Account_Take_3',
    AccountTake4: 'Account_Take_4',
    AccountTake5: 'Account_Take_5',
    AccountTake6: 'Account_Take_6',
    AccountTake7: 'Account_Take_7',
    Accountant: 'Accountant',
    Auditor: 'Auditor',
    BrandManager: 'Brand_Manager',
    CommunicationsOfficer: 'Communications_Officer',
    ConfigEquipment: 'Config_Equipment',
    ConfigStarbaseEquipment: 'Config_Starbase_Equipment',
    ContainerTake1: 'Container_Take_1',
    ContainerTake2: 'Container_Take_2',
    ContainerTake3: 'Container_Take_3',
    ContainerTake4: 'Container_Take_4',
    ContainerTake5: 'Container_Take_5',
    ContainerTake6: 'Container_Take_6',
    ContainerTake7: 'Container_Take_7',
    ContractManager: 'Contract_Manager',
    DeliveriesContainerTake: 'Deliveries_Container_Take',
    DeliveriesQuery: 'Deliveries_Query',
    DeliveriesTake: 'Deliveries_Take',
    Diplomat: 'Diplomat',
    Director: 'Director',
    FactoryManager: 'Factory_Manager',
    FittingManager: 'Fitting_Manager',
    HangarQuery1: 'Hangar_Query_1',
    HangarQuery2: 'Hangar_Query_2',
    HangarQuery3: 'Hangar_Query_3',
    HangarQuery4: 'Hangar_Query_4',
    HangarQuery5: 'Hangar_Query_5',
    HangarQuery6: 'Hangar_Query_6',
    HangarQuery7: 'Hangar_Query_7',
    HangarTake1: 'Hangar_Take_1',
    HangarTake2: 'Hangar_Take_2',
    HangarTake3: 'Hangar_Take_3',
    HangarTake4: 'Hangar_Take_4',
    HangarTake5: 'Hangar_Take_5',
    HangarTake6: 'Hangar_Take_6',
    HangarTake7: 'Hangar_Take_7',
    JuniorAccountant: 'Junior_Accountant',
    PersonnelManager: 'Personnel_Manager',
    ProjectManager: 'Project_Manager',
    RentFactoryFacility: 'Rent_Factory_Facility',
    RentOffice: 'Rent_Office',
    RentResearchFacility: 'Rent_Research_Facility',
    SecurityOfficer: 'Security_Officer',
    SkillPlanManager: 'Skill_Plan_Manager',
    StarbaseDefenseOperator: 'Starbase_Defense_Operator',
    StarbaseFuelTechnician: 'Starbase_Fuel_Technician',
    StationManager: 'Station_Manager',
    Trader: 'Trader'
} as const;
export type GetCharactersCharacterIdRolesOkRolesAtBaseEnum = typeof GetCharactersCharacterIdRolesOkRolesAtBaseEnum[keyof typeof GetCharactersCharacterIdRolesOkRolesAtBaseEnum];

/**
 * @export
 */
export const GetCharactersCharacterIdRolesOkRolesAtHqEnum = {
    AccountTake1: 'Account_Take_1',
    AccountTake2: 'Account_Take_2',
    AccountTake3: 'Account_Take_3',
    AccountTake4: 'Account_Take_4',
    AccountTake5: 'Account_Take_5',
    AccountTake6: 'Account_Take_6',
    AccountTake7: 'Account_Take_7',
    Accountant: 'Accountant',
    Auditor: 'Auditor',
    BrandManager: 'Brand_Manager',
    CommunicationsOfficer: 'Communications_Officer',
    ConfigEquipment: 'Config_Equipment',
    ConfigStarbaseEquipment: 'Config_Starbase_Equipment',
    ContainerTake1: 'Container_Take_1',
    ContainerTake2: 'Container_Take_2',
    ContainerTake3: 'Container_Take_3',
    ContainerTake4: 'Container_Take_4',
    ContainerTake5: 'Container_Take_5',
    ContainerTake6: 'Container_Take_6',
    ContainerTake7: 'Container_Take_7',
    ContractManager: 'Contract_Manager',
    DeliveriesContainerTake: 'Deliveries_Container_Take',
    DeliveriesQuery: 'Deliveries_Query',
    DeliveriesTake: 'Deliveries_Take',
    Diplomat: 'Diplomat',
    Director: 'Director',
    FactoryManager: 'Factory_Manager',
    FittingManager: 'Fitting_Manager',
    HangarQuery1: 'Hangar_Query_1',
    HangarQuery2: 'Hangar_Query_2',
    HangarQuery3: 'Hangar_Query_3',
    HangarQuery4: 'Hangar_Query_4',
    HangarQuery5: 'Hangar_Query_5',
    HangarQuery6: 'Hangar_Query_6',
    HangarQuery7: 'Hangar_Query_7',
    HangarTake1: 'Hangar_Take_1',
    HangarTake2: 'Hangar_Take_2',
    HangarTake3: 'Hangar_Take_3',
    HangarTake4: 'Hangar_Take_4',
    HangarTake5: 'Hangar_Take_5',
    HangarTake6: 'Hangar_Take_6',
    HangarTake7: 'Hangar_Take_7',
    JuniorAccountant: 'Junior_Accountant',
    PersonnelManager: 'Personnel_Manager',
    ProjectManager: 'Project_Manager',
    RentFactoryFacility: 'Rent_Factory_Facility',
    RentOffice: 'Rent_Office',
    RentResearchFacility: 'Rent_Research_Facility',
    SecurityOfficer: 'Security_Officer',
    SkillPlanManager: 'Skill_Plan_Manager',
    StarbaseDefenseOperator: 'Starbase_Defense_Operator',
    StarbaseFuelTechnician: 'Starbase_Fuel_Technician',
    StationManager: 'Station_Manager',
    Trader: 'Trader'
} as const;
export type GetCharactersCharacterIdRolesOkRolesAtHqEnum = typeof GetCharactersCharacterIdRolesOkRolesAtHqEnum[keyof typeof GetCharactersCharacterIdRolesOkRolesAtHqEnum];

/**
 * @export
 */
export const GetCharactersCharacterIdRolesOkRolesAtOtherEnum = {
    AccountTake1: 'Account_Take_1',
    AccountTake2: 'Account_Take_2',
    AccountTake3: 'Account_Take_3',
    AccountTake4: 'Account_Take_4',
    AccountTake5: 'Account_Take_5',
    AccountTake6: 'Account_Take_6',
    AccountTake7: 'Account_Take_7',
    Accountant: 'Accountant',
    Auditor: 'Auditor',
    BrandManager: 'Brand_Manager',
    CommunicationsOfficer: 'Communications_Officer',
    ConfigEquipment: 'Config_Equipment',
    ConfigStarbaseEquipment: 'Config_Starbase_Equipment',
    ContainerTake1: 'Container_Take_1',
    ContainerTake2: 'Container_Take_2',
    ContainerTake3: 'Container_Take_3',
    ContainerTake4: 'Container_Take_4',
    ContainerTake5: 'Container_Take_5',
    ContainerTake6: 'Container_Take_6',
    ContainerTake7: 'Container_Take_7',
    ContractManager: 'Contract_Manager',
    DeliveriesContainerTake: 'Deliveries_Container_Take',
    DeliveriesQuery: 'Deliveries_Query',
    DeliveriesTake: 'Deliveries_Take',
    Diplomat: 'Diplomat',
    Director: 'Director',
    FactoryManager: 'Factory_Manager',
    FittingManager: 'Fitting_Manager',
    HangarQuery1: 'Hangar_Query_1',
    HangarQuery2: 'Hangar_Query_2',
    HangarQuery3: 'Hangar_Query_3',
    HangarQuery4: 'Hangar_Query_4',
    HangarQuery5: 'Hangar_Query_5',
    HangarQuery6: 'Hangar_Query_6',
    HangarQuery7: 'Hangar_Query_7',
    HangarTake1: 'Hangar_Take_1',
    HangarTake2: 'Hangar_Take_2',
    HangarTake3: 'Hangar_Take_3',
    HangarTake4: 'Hangar_Take_4',
    HangarTake5: 'Hangar_Take_5',
    HangarTake6: 'Hangar_Take_6',
    HangarTake7: 'Hangar_Take_7',
    JuniorAccountant: 'Junior_Accountant',
    PersonnelManager: 'Personnel_Manager',
    ProjectManager: 'Project_Manager',
    RentFactoryFacility: 'Rent_Factory_Facility',
    RentOffice: 'Rent_Office',
    RentResearchFacility: 'Rent_Research_Facility',
    SecurityOfficer: 'Security_Officer',
    SkillPlanManager: 'Skill_Plan_Manager',
    StarbaseDefenseOperator: 'Starbase_Defense_Operator',
    StarbaseFuelTechnician: 'Starbase_Fuel_Technician',
    StationManager: 'Station_Manager',
    Trader: 'Trader'
} as const;
export type GetCharactersCharacterIdRolesOkRolesAtOtherEnum = typeof GetCharactersCharacterIdRolesOkRolesAtOtherEnum[keyof typeof GetCharactersCharacterIdRolesOkRolesAtOtherEnum];


/**
 * Check if a given object implements the GetCharactersCharacterIdRolesOk interface.
 */
export function instanceOfGetCharactersCharacterIdRolesOk(value: object): value is GetCharactersCharacterIdRolesOk {
    return true;
}

export function GetCharactersCharacterIdRolesOkFromJSON(json: any): GetCharactersCharacterIdRolesOk {
    return GetCharactersCharacterIdRolesOkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdRolesOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdRolesOk {
    if (json == null) {
        return json;
    }
    return {
        
        'roles': json['roles'] == null ? undefined : json['roles'],
        'rolesAtBase': json['roles_at_base'] == null ? undefined : json['roles_at_base'],
        'rolesAtHq': json['roles_at_hq'] == null ? undefined : json['roles_at_hq'],
        'rolesAtOther': json['roles_at_other'] == null ? undefined : json['roles_at_other'],
    };
}

export function GetCharactersCharacterIdRolesOkToJSON(json: any): GetCharactersCharacterIdRolesOk {
    return GetCharactersCharacterIdRolesOkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdRolesOkToJSONTyped(value?: GetCharactersCharacterIdRolesOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roles': value['roles'],
        'roles_at_base': value['rolesAtBase'],
        'roles_at_hq': value['rolesAtHq'],
        'roles_at_other': value['rolesAtOther'],
    };
}

